import React from 'react';
import PropTypes from 'prop-types';

function Alert({ type = 'info', message }) {
    if (!message) {
        return null;
    }

    return (
        <div
            className={`alert alert-${type}`}
            role="alert"
        >
            {message}
        </div>
    );
}

Alert.propTypes = {
    type: PropTypes.string,
    message: PropTypes.node,
};

export default Alert;


// WEBPACK FOOTER //
// ./src/components/common/Alert.js